/* Cajón del carrito: botón "Agregar" de la sugerencia de envío gratis. Agrega sin recargar, actualiza el ícono del carrito y refresca el cajón. */
(function(){
  if(window.__bjCartX)return;window.__bjCartX=1;
  function refreshDrawer(){
    var cur=document.querySelector('#shopify-section-cart-drawer-section');
    if(!cur)return Promise.resolve();
    return fetch('/?sections=cart-drawer-section',{credentials:'same-origin'}).then(function(r){return r.json()}).then(function(j){
      var d=new DOMParser().parseFromString(j['cart-drawer-section']||'','text/html');
      var n=d.querySelector('#shopify-section-cart-drawer-section');
      if(n)cur.innerHTML=n.innerHTML;
    }).catch(function(){});
  }
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-bjcs-add]');
    if(!b||b.disabled)return;
    var label=b.textContent;
    b.disabled=true;b.textContent='Agregando…';
    fetch('/cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:parseInt(b.dataset.id,10),quantity:1}]})})
      .then(function(r){if(!r.ok)throw new Error('add');return r.json()})
      .then(function(){return fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json()})})
      .then(function(c){
        var ci=document.querySelector('cart-icon');
        if(ci&&typeof ci.renderCartBubble==='function')ci.renderCartBubble(c.item_count);
        return refreshDrawer();
      })
      .then(function(){
        var dr=document.querySelector('#cart-drawer');
        if(dr&&typeof dr.open==='function')dr.open();
      })
      .catch(function(){b.textContent='No se pudo agregar';setTimeout(function(){b.disabled=false;b.textContent=label},2400)});
  });
})();

(function () {
  if (window.__bjCartRecoClose) return;
  window.__bjCartRecoClose = true;
  var dismissed = false;
  function init() {
    var root = document.getElementById('shopify-section-cart-drawer-section');
    if (!root) return;
    function sync() {
      root.querySelectorAll('.bjcs__r').forEach(function (panel) {
        if (dismissed) {
          if (!panel.hidden) panel.hidden = true;
          return;
        }
        if (panel.querySelector('[data-bjcs-close]')) return;
        panel.style.position = 'relative';
        var heading = panel.querySelector('p');
        if (heading) heading.style.paddingRight = '30px';
        var close = document.createElement('button');
        close.type = 'button';
        close.setAttribute('data-bjcs-close', '');
        close.setAttribute('aria-label', 'Cerrar sugerencias de productos');
        close.textContent = '×';
        close.style.cssText = 'position:absolute;top:4px;right:4px;width:36px;height:36px;display:grid;place-items:center;border:0;border-radius:50%;background:transparent;color:#3c3c3b;font:26px/1 Arial;cursor:pointer';
        panel.prepend(close);
      });
    }
    root.addEventListener('click', function (event) {
      var close = event.target.closest('[data-bjcs-close]');
      if (!close) return;
      event.preventDefault();
      dismissed = true;
      close.closest('.bjcs__r').hidden = true;
    });
    new MutationObserver(sync).observe(root, { childList: true, subtree: true });
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
